package com.starparty.app.astro0


/**
 * Title:        Starparty Astro-0
 * Description:  Simply astronomy package for starparty.com and sennen-cove-cornwall.uk
 * Copyright:    Copyright (c) 2021
 * Company: starparty.com
 * @author Rob Leeson
 * @version 2.0
 */

abstract class SP_Time(val year: Int,
                       val month: Int,
                       val dayOfMonth: Int,
                       val hour: Int,
                       val minute: Int,
                       val second: Int,
                       val millisecond: Int) {

    fun yearUTC(): Int {
        return year
    }

    fun monthUTC(): Int {
        return month
    }

    fun dayOfMonthUTC(): Int {
        return dayOfMonth
    }

    fun hourOfDayUTC(): Int {
        return hour
    }

    fun minuteUTC(): Int {
        return minute
    }

    fun secondUTC(): Int {
        return second
    }

    fun millisecondUTC(): Int {
        return millisecond
    }

    override fun toString(): String {
        return "${yearUTC()}.${monthUTC()}.${dayOfMonthUTC()} ${hourOfDayUTC()}:${minuteUTC()}:${secondUTC()}:${millisecondUTC()}"
    }

    val epoch:Int
       get(){
        return yearUTC()
       }

    /** Returns sidereal time in degrees at prime meridian.
     * The approximation is within 0.3 seconds of time
     * for dates within 100 years of J2000.  */
    val siderealTime: Double
        get() {
            val LST_C = 100.46
            val LST_M = 0.985647
            val d = daysFromJ2000
            val ut = universalTime
            val siderealTime = LST_C + LST_M * d + 15 * ut
            return siderealTime
        }

    val julianDate: Double get() = daysFromJ2000 + 2451543.5 //2451545.0

    // long msDif = itsTime.getTime().getTime() - J2000.getTime().getTime();
    // return ((double)msDif) / DAYS_TO_MS;
    val daysFromJ2000: Double
        get() = dayNumber// Months are zero indexed!

    //  double JDN2000 = 2451543.5;
    //  double d2000 = d + JDN2000;

    val dayNumber: Double
        get() {
            val ut = universalTime

            val y:Int = yearUTC()
            val m:Int = monthUTC()
            val D:Int = dayOfMonthUTC()
            var d:Double =
                    367 * y - 7 * (y + (m + 9) / 12) / 4 - 3 * ((y + (m - 9) / 7) / 100 + 1) / 4 + 275 * m / 9 + D - 730515.toDouble()
            val dayFraction = ut / 24.0
            d = d + dayFraction

//Log.v("SP", "dayNumber: $d, universalTime: $universalTime, secondUTC: ${secondUTC()}")
            //  double JDN2000 = 2451543.5;
            //  double d2000 = d + JDN2000;
            return d
        }

    val universalTime: Double
        get() {
            val hour = hourOfDayUTC()
            val min = minuteUTC()
            val sec = secondUTC()
            val ms = millisecondUTC()
            return hour + min.toDouble() / HRS_TO_MINS() + sec.toDouble() / HRS_TO_SECS() + ms.toDouble() / HRS_TO_MS()
        }

    companion object {

        fun HOURS_TO_DEGS(): Int { return 15 }
        fun DAYS_TO_HRS(): Int { return 24 }
        fun HRS_TO_MINS(): Int { return 60 }
        fun MINS_TO_SECS(): Int { return 60 }
        fun SECS_TO_MS(): Int { return 1000 }
        fun HRS_TO_SECS(): Int { return HRS_TO_MINS() * MINS_TO_SECS() }
        fun HRS_TO_MS(): Int { return HRS_TO_SECS() * SECS_TO_MS() }
        fun DAYS_TO_MS(): Int { return DAYS_TO_HRS() * HRS_TO_MS() }
        fun MINS_TO_MS(): Int { return MINS_TO_SECS() * SECS_TO_MS() }
        protected fun DEF_UPDATE_DELAY(): Int { return 100 }
        protected fun DEF_INTERVAL(): Int { return MINS_TO_SECS() }

    }


    abstract fun incrementByMilliseconds(delta:Double): SP_Time
}